// extracted by mini-css-extract-plugin
export var resizer = "_gi-0";